
import { defineComponent } from 'vue'
import useCurrentUser, { useProfileShow } from '@/composables/user/user'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import useProfileMenu, { ProfileMenu } from '@/composables/profile/profileMenu'
import useSubscriberManager, {
  useRemoveUserSubscription,
  useSubscribeUser,
} from '@/composables/subscribers/subscribersManager'
import { useRouter } from '@/routing/router'
import { DateTimeHelper } from '@/helper/dateTime'
import AllPostList from '@/components/Profile/Lists/AllPostList.vue'
import SubscriberPostList from '@/components/Profile/Lists/SubscribersPostList.vue'
import HiddenPostList from '@/components/Profile/Lists/HiddenPostList.vue'
import FollowersPostList from '@/components/Profile/Lists/FollowersPostList.vue'
import AllPostRepliesList from '@/components/Profile/Lists/AllPostRepliesList.vue'
import UnusedPostRepliesList from '@/components/Profile/Lists/UnseenPostRepliesList.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import UserProfileMenu from '@/components/Profile/Menu/UserProfileMenu.vue'
import { useProfileUserBlock } from '@/composables/userBlock/userBlock'
import BlockedUserList from '@/components/Profile/Lists/BlockedUserList.vue'
import ReportedPostList from '@/components/Profile/ReportedPostList.vue'
import { usePostListUiActions } from '@/composables/ui/uiActions'
import ProfileApiError from '@/components/Profile/Error/ProfileApiError.vue'
import SuperLikeList from '@/components/Profile/SuperLikeList.vue'
import AUserProfileMetaRow from '@/components/Ui/Profile/UserProfileMetaRow.vue'
import AUserProfileMetaItem from '@/components/Ui/Profile/UserProfileMetaItem.vue'
import APremium from '@/components/Ui/Badge/Premium.vue'

export default defineComponent({
  name: 'UserProfile',
  components: {
    APremium,
    AUserProfileMetaItem,
    AUserProfileMetaRow,
    SuperLikeList,
    ProfileApiError,
    ReportedPostList,
    BlockedUserList,
    UserProfileMenu,
    TechnicalShutdown,
    UnusedPostRepliesList,
    AllPostRepliesList,
    FollowersPostList,
    HiddenPostList,
    SubscriberPostList,
    AllPostList,
    AButton,
    AIcon,
  },
  data() {
    return {
      SUBSCRIBERS: ProfileMenu.SUBSCRIBERS,
      FOLLOWERS: ProfileMenu.FOLLOWERS,
      ALL_POSTS: ProfileMenu.ALL_POSTS,
      HIDDEN_POSTS: ProfileMenu.HIDDEN_POSTS,
      UNSEEN_REPLIES_POSTS: ProfileMenu.UNSEEN_REPLIES_POSTS,
      ALL_REPLIES_POSTS: ProfileMenu.ALL_REPLIES_POSTS,
      BLACKLIST: ProfileMenu.BLACKLIST,
      REPORTED: ProfileMenu.REPORTED,
      SUPER_LIKE: ProfileMenu.SUPER_LIKE,
    }
  },
  methods: {
    formatDateTime(date: string) {
      return DateTimeHelper.formatDateTimeFromString(date)
    },
  },
  async setup() {
    const { currentUser, loggedIn } = useCurrentUser()
    const { profile, loadProfile, isShowingCurrentUser } = useProfileShow()
    const {
      isSubscribedInitialized,
      currentUserSubscription,
      fetchIsUserSubscribed,
    } = useSubscriberManager()

    await loadProfile()
    if (!isShowingCurrentUser.value && loggedIn.value) {
      fetchIsUserSubscribed(profile.value?.id ?? 0)
    }

    const { init } = useProfileMenu()
    init()

    return {
      profile,
      currentUser,
      isShowingCurrentUser,
      loggedIn,
      isSubscribedInitialized,
      currentUserSubscription,
      ...useSubscribeUser(profile.value?.id ?? 0),
      ...useRemoveUserSubscription(),
      ...useRouter(),
      ...useProfileMenu(),
      ...usePostListUiActions(),
      ...useProfileUserBlock(profile.value?.id ?? 0),
    }
  },
})
